import { render } from "./ContentCard.vue?vue&type=template&id=4184cae0"
import script from "./ContentCard.vue?vue&type=script&lang=js"
export * from "./ContentCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/ContentCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4184cae0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4184cae0', __exports__)) {
    api.reload('4184cae0', __exports__)
  }
  
  module.hot.accept("./ContentCard.vue?vue&type=template&id=4184cae0", () => {
    api.rerender('4184cae0', render)
  })

}


export default __exports__